export default class {
    TmaDaxId = null;

    Name = null;

    Mechanic = null;

    Discount = null;

    StartDate = null;

    EndDate = null;

    Dmp = null;

    Catalog = null;

    Aeps = null;
  
    RawAeps = null;

    mapFromDto(dto) {
        if(!dto)
            return this;

        this.TmaDaxId = dto.TmaDaxId;
        this.Name = dto.Name;
        this.Mechanic = dto.Mechanic;
        this.Discount = dto.Discount;
        this.StartDate = dto.StartDate;
        this.EndDate = dto.EndDate;
        this.Catalog = dto.Catalog;
        this.Dmp = dto.Dmp;

        this.Aeps = dto.Aeps && dto.Aeps.length
            ? dto.Aeps
        : [];
      
        this.RawAeps = dto.RawAeps && dto.RawAeps.length
          ? dto.RawAeps
          : [];

        return this;
    }
    
}